module.exports = __webpack_public_path__ + "img/exchange-selected-white.e12c0f4d.png";